/**
 * Variant Bundle JavaScript
 * Handles variant bundle functionality independently from custom.js
 */
document.addEventListener('DOMContentLoaded', function() {
  const wrapper = document.querySelector('.variant-bundle-wrapper');
  if (!wrapper) return;

  // Elements - use variant-bundler-section instead of product-bundler
  const sizeBtns = wrapper.querySelectorAll('.variant-bundle-size');
  const switchBtns = wrapper.querySelectorAll('.variant-bundle-switch .custom-button');
  const bundler = wrapper.querySelector('.variant-bundler-section');
  const singleAddBtn = wrapper.querySelector('.variant-single-add-btn');
  const addToCartBtn = wrapper.querySelector('.custom-add-to-cart');
  const bundleOptions = wrapper.querySelector('.variant-bundle-options');
  const fiveMlSection = wrapper.querySelector('.variant-5ml-add-section');
  const fiveMlAddBtn = wrapper.querySelector('.variant-5ml-add-btn');
  const sizeLists = wrapper.querySelectorAll('.flavors-size-list');

  // State
  let selectedSize = wrapper.querySelector('.variant-bundle-size.active')?.dataset.size || '50ml';

  // Prices from data attributes
  const prices = {
    '50ml': {
      1: parseInt(wrapper.getAttribute('data-price-1-50ml')) || 279,
      2: parseInt(wrapper.getAttribute('data-price-2-50ml')) || 558,
      3: parseInt(wrapper.getAttribute('data-price-3-50ml')) || 679
    },
    '100ml': {
      1: parseInt(wrapper.getAttribute('data-price-1-100ml')) || 399,
      2: parseInt(wrapper.getAttribute('data-price-2-100ml')) || 798,
      3: parseInt(wrapper.getAttribute('data-price-3-100ml')) || 998
    }
  };

  /**
   * Get the correct variant ID based on selected size
   */
  function getVariantId(card) {
    if (selectedSize === '50ml') {
      return card.getAttribute('data-variant-50ml-id');
    } else {
      return card.getAttribute('data-variant-100ml-id');
    }
  }

  /**
   * Update main product price at top of page based on selected variant
   */
  function updateMainPrice(variantId) {
    if (!variantId) return;
    
    // Format prices - Shopify prices are in cents
    const formatPrice = (price) => {
      const priceInKr = price / 100;
      return priceInKr.toLocaleString('da-DK', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace('.', ',') + ' kr';
    };
    
    // Get product path properly
    const pathParts = window.location.pathname.split('/');
    const productIndex = pathParts.indexOf('products');
    let productPath = window.location.pathname;
    if (productIndex !== -1) {
      productPath = '/' + pathParts.slice(productIndex, productIndex + 2).join('/');
    }
    
    // Fetch variant data
    fetch(productPath + '.js')
      .then(res => {
        if (!res.ok) throw new Error('Failed to fetch product data');
        return res.json();
      })
      .then(product => {
        const variant = product.variants.find(v => v.id === parseInt(variantId));
        if (!variant) {
          console.warn('Variant not found:', variantId);
          return;
        }
        
        console.log('Updating price for variant:', variant.title, 'Price:', variant.price, 'Compare:', variant.compare_at_price);
        
        // Update ALL price elements on the page - use multiple selectors
        const priceSelectors = [
          '[data-js-product-price-original]',
          '.product-price--original',
          '.main-product-price .product-price--original',
          '.product-price .current-price'
        ];
        
        const compareSelectors = [
          '[data-js-product-price-compare]',
          '.product-price--compare',
          '.main-product-price .product-price--compare',
          '.product-price .compare-price'
        ];
        
        // Update original price
        priceSelectors.forEach(selector => {
          document.querySelectorAll(selector).forEach(el => {
            el.textContent = formatPrice(variant.price);
          });
        });
        
        // Update compare at price
        compareSelectors.forEach(selector => {
          document.querySelectorAll(selector).forEach(el => {
            if (variant.compare_at_price && variant.compare_at_price > variant.price) {
              // Check if element is .compare-price (uses <s> tag) or other (uses <span>)
              if (el.classList.contains('compare-price')) {
                el.innerHTML = '<s>' + formatPrice(variant.compare_at_price) + '</s>';
                el.style.display = '';
              } else {
                el.innerHTML = '<span>' + formatPrice(variant.compare_at_price) + '</span>';
              }
            } else {
              el.innerHTML = '';
              if (el.classList.contains('compare-price')) {
                el.style.display = 'none';
              }
            }
          });
        });
        
        // Also ensure compare-price element exists and is visible when needed
        const comparePriceEl = document.querySelector('.product-price .compare-price');
        if (!comparePriceEl && variant.compare_at_price && variant.compare_at_price > variant.price) {
          const productPriceContainer = document.querySelector('.product-price');
          if (productPriceContainer) {
            const newCompareEl = document.createElement('span');
            newCompareEl.className = 'compare-price';
            newCompareEl.innerHTML = '<s>' + formatPrice(variant.compare_at_price) + '</s>';
            productPriceContainer.appendChild(newCompareEl);
          }
        }
      })
      .catch(err => console.error('Error fetching variant price:', err));
  }

  /**
   * Open cart drawer without page refresh
   */
  function openCartDrawer() {
    // Try multiple methods to open cart drawer
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.open === 'function') {
      cartDrawer.open();
      return;
    }

    // Try clicking cart icon
    const cartIcon = document.querySelector('.header__icon--cart, [data-cart-toggle], .cart-icon-bubble, a[href="/cart"]');
    if (cartIcon) {
      cartIcon.click();
      return;
    }

    // Try dispatching custom event
    document.dispatchEvent(new CustomEvent('cart:open'));
    
    // Try Shopify's cart drawer
    const shopifyCartDrawer = document.querySelector('#CartDrawer, .cart-drawer, #cart-drawer');
    if (shopifyCartDrawer) {
      shopifyCartDrawer.classList.add('is-open', 'active', 'drawer--is-open');
      document.body.classList.add('overflow-hidden', 'cart-drawer-open');
    }
  }

  /**
   * Update cart count in header
   */
  function updateCartCount() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const cartCounts = document.querySelectorAll('.cart-count-bubble span, .cart-count, [data-cart-count]');
        cartCounts.forEach(el => {
          el.textContent = cart.item_count;
        });
      })
      .catch(() => {});
  }

  /**
   * Get the currently active flavors list based on selected size
   */
  function getActiveFlavorsList() {
    if (!bundler) return null;
    // Find the visible size list
    const activeList = bundler.querySelector('.flavors-size-list[data-size-list="' + selectedSize + '"]');
    return activeList || bundler.querySelector('.flavors-size-list:not([style*="display: none"])') || bundler.querySelector('.flavors-container');
  }

  /**
   * Switch the visible product list based on selected size
   */
  function switchSizeList(size) {
    if (!bundler) return;
    sizeLists.forEach(list => {
      if (list.dataset.sizeList === size) {
        list.style.display = '';
      } else {
        list.style.display = 'none';
      }
    });
  }

  /**
   * Reset quantities in a flavors list
   */
  function resetFlavorsList(list) {
    if (!list) return;
    list.querySelectorAll('.flavor_card-item').forEach(card => {
      const display = card.querySelector('.flavor_qty-display');
      const addBtn = card.querySelector('.flavor_add-btn');
      if (display) {
        if (card.dataset.isCurrent === 'true') {
          display.textContent = '1';
          if (addBtn) addBtn.classList.remove('is-active');
        } else {
          display.textContent = '0';
          if (addBtn) addBtn.classList.add('is-active');
        }
      }
    });
  }

  /**
   * Update meter based on total quantity
   */
  function updateMeter() {
    if (!bundler) return;
    
    const activeList = getActiveFlavorsList();
    let totalQty = 0;
    if (activeList) {
      activeList.querySelectorAll('.flavor_card-item').forEach(card => {
        const display = card.querySelector('.flavor_qty-display');
        if (display) {
          totalQty += parseInt(display.textContent, 10) || 0;
        }
      });
    }

    // Update circles
    const circles = bundler.querySelectorAll('.quantity-meter-item__circle');
    const inners = bundler.querySelectorAll('.quantity-meter-item__circle-inner');
    
    circles.forEach((circle, index) => {
      const threshold = index + 1;
      if (totalQty >= threshold) {
        circle.classList.add('filled');
        if (inners[index]) inners[index].classList.add('filled');
      } else {
        circle.classList.remove('filled');
        if (inners[index]) inners[index].classList.remove('filled');
      }
    });

    // Update line
    const line = bundler.querySelector('.quantity-meter-line.filled');
    if (line) {
      if (totalQty <= 1) {
        line.style.width = '0';
      } else {
        const items = bundler.querySelectorAll('.quantity-meter-item');
        const container = bundler.querySelector('.quantity-meter-items');
        if (items.length >= 2 && container) {
          const containerRect = container.getBoundingClientRect();
          const firstCircle = items[0].querySelector('.quantity-meter-item__circle');
          const startX = firstCircle.getBoundingClientRect().left + firstCircle.offsetWidth / 2 - containerRect.left;

          if (totalQty >= 3) {
            // At 3+, fill the entire remaining gray line
            const grayLine = bundler.querySelector('.quantity-meter-line:not(.filled)');
            if (grayLine) {
              const grayRect = grayLine.getBoundingClientRect();
              const endX = grayRect.right - containerRect.left;
              line.style.marginLeft = startX + 'px';
              line.style.width = (endX - startX) + 'px';
            }
          } else {
            const targetIndex = Math.min(totalQty - 1, items.length - 1);
            const targetCircle = items[targetIndex].querySelector('.quantity-meter-item__circle');
            const endX = targetCircle.getBoundingClientRect().left + targetCircle.offsetWidth / 2 - containerRect.left;
            line.style.marginLeft = startX + 'px';
            line.style.width = (endX - startX) + 'px';
          }
        }
      }
    }

    // Update price based on tier
    const currentPrices = prices[selectedSize];
    let bundlePrice = 0;
    if (currentPrices) {
      if (totalQty === 0) bundlePrice = 0;
      else if (totalQty === 1) bundlePrice = currentPrices[1];
      else if (totalQty === 2) bundlePrice = currentPrices[2];
      else if (totalQty === 3) bundlePrice = currentPrices[3];
      else if (totalQty > 3) {
        // For 4+ items: tier 3 price + extra items at per-item rate
        const pricePerItem = Math.round(currentPrices[3] / 3);
        bundlePrice = currentPrices[3] + ((totalQty - 3) * pricePerItem);
      }
    }

    const bundleTotalEl = bundler.querySelector('.bundle-cart-price');
    if (bundleTotalEl) {
      bundleTotalEl.textContent = bundlePrice + ' kr';
    }

    // Enable/disable button
    if (addToCartBtn) {
      if (totalQty >= 1) {
        addToCartBtn.classList.add('is-active');
      } else {
        addToCartBtn.classList.remove('is-active');
      }
    }
  }

  /**
   * Update price displays
   */
  function updatePriceDisplays() {
    const currentPrices = prices[selectedSize];
    if (!currentPrices) return;

    // Get compare-at price from data attributes (in cents)
    const compareAtPrice = selectedSize === '100ml' 
      ? parseInt(wrapper.getAttribute('data-compare-100ml')) || 49900
      : parseInt(wrapper.getAttribute('data-compare-50ml')) || 34900;
    
    // Format compare-at price
    const formatComparePrice = (priceInCents) => {
      return (priceInCents / 100).toLocaleString('da-DK', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace('.', ',') + ' kr';
    };
    const formattedComparePrice = formatComparePrice(compareAtPrice);

    // Update "1 parfume" price
    const singlePriceDisplay = wrapper.querySelector('.single-price-display');
    if (singlePriceDisplay) {
      singlePriceDisplay.textContent = currentPrices[1] + ',00 kr';
    }

    // Update "1 parfume" compare-at price
    const singleCompareDisplay = wrapper.querySelector('.single-compare-display');
    if (singleCompareDisplay) {
      singleCompareDisplay.textContent = formattedComparePrice;
    }

    // Update "Flere parfumer" price - show the BEST price per bottle (3 bottles / 3)
    const bundlePriceDisplay = wrapper.querySelector('.bundle-price-display');
    if (bundlePriceDisplay) {
      const bestPricePerBottle = Math.round(currentPrices[3] / 3);
      bundlePriceDisplay.textContent = bestPricePerBottle + ',00 kr';
    }

    // Update "Flere parfumer" compare-at price
    const bundleCompareEls = wrapper.querySelectorAll('.variant-bundle-switch .custom-button[data-type="bundle"] .compare-at-price del');
    bundleCompareEls.forEach(el => {
      el.textContent = formattedComparePrice;
    });

    const subtitleEl = wrapper.querySelector('.bundle-subtitle-2');
    if (subtitleEl) {
      const subtitle = wrapper.getAttribute('data-subtitle-' + selectedSize);
      if (subtitle) subtitleEl.textContent = subtitle;
    }

    // Update single add button price and compare-at
    if (singleAddBtn) {
      const btnTotal = singleAddBtn.querySelector('.btn-total');
      if (btnTotal) btnTotal.textContent = currentPrices[1] + ',00 kr';
      
      const btnCompare = singleAddBtn.querySelector('.btn-compare');
      if (btnCompare) btnCompare.textContent = formattedComparePrice;
    }

    // Update quantity meter prices
    const meterItems = bundler?.querySelectorAll('.quantity-meter-item');
    if (meterItems) {
      meterItems.forEach((item, index) => {
        const priceEl = item.querySelector('.quantity-meter-item__price');
        if (priceEl && currentPrices[index + 1]) {
          priceEl.textContent = currentPrices[index + 1] + ' kr';
        }
      });
    }
  }

  // Size button click
  sizeBtns.forEach(btn => {
    btn.addEventListener('click', function() {
      sizeBtns.forEach(b => b.classList.remove('active'));
      this.classList.add('active');
      selectedSize = this.dataset.size;
      
      // Update the main product price display at the top
      updateMainPrice(this.dataset.variantId);
      
      const bisSection = wrapper.querySelector('.variant-bundle-bis-section');

      if (this.dataset.soldOut === 'true') {
        if (bundleOptions) bundleOptions.style.display = 'none';
        if (fiveMlSection) fiveMlSection.style.display = 'none';
        if (bisSection) bisSection.style.display = 'block';
      } else if (this.dataset.noBundle === 'true') {
        if (bundleOptions) bundleOptions.style.display = 'none';
        if (fiveMlSection) fiveMlSection.style.display = 'block';
        if (bisSection) bisSection.style.display = 'none';
      } else {
        if (bundleOptions) bundleOptions.style.display = 'block';
        if (fiveMlSection) fiveMlSection.style.display = 'none';
        if (bisSection) bisSection.style.display = 'none';
        
        // Switch the product list to match selected size
        switchSizeList(selectedSize);
        
        // Reset quantities in the newly visible list
        const activeList = getActiveFlavorsList();
        resetFlavorsList(activeList);
        
        updatePriceDisplays();
        updateMeter();
      }
    });
  });

  // Toggle 1 parfume / Flere parfumer
  switchBtns.forEach(btn => {
    btn.addEventListener('click', function() {
      switchBtns.forEach(b => b.classList.remove('active'));
      this.classList.add('active');
      
      const type = this.getAttribute('data-type');
      const bundleMode = type === 'bundle';
      
      if (bundleMode) {
        if (bundler) bundler.style.display = 'block';
        if (singleAddBtn) singleAddBtn.style.display = 'none';
        requestAnimationFrame(positionGrayLine);
      } else {
        if (bundler) bundler.style.display = 'none';
        if (singleAddBtn) singleAddBtn.style.display = 'block';
      }
    });
  });

  // Position the gray line precisely between first and last circle
  function positionGrayLine() {
    if (!bundler) return;
    const grayLine = bundler.querySelector('.quantity-meter-line:not(.filled)');
    const items = bundler.querySelectorAll('.quantity-meter-item');
    const container = bundler.querySelector('.quantity-meter-items');
    if (!grayLine || items.length < 2 || !container) return;

    const containerRect = container.getBoundingClientRect();
    const firstCircle = items[0].querySelector('.quantity-meter-item__circle');
    const lastCircle = items[items.length - 1].querySelector('.quantity-meter-item__circle');
    if (!firstCircle || !lastCircle) return;

    const startX = firstCircle.getBoundingClientRect().left + firstCircle.offsetWidth / 2 - containerRect.left;
    const endX = lastCircle.getBoundingClientRect().left + lastCircle.offsetWidth / 2 - containerRect.left;

    grayLine.style.left = startX + 'px';
    grayLine.style.width = (endX - startX) + 'px';
    grayLine.style.transform = 'translateY(-50%)';
  }

  window.addEventListener('resize', positionGrayLine);

  // Bundler click handling
  if (bundler) {
    bundler.addEventListener('click', function(e) {
      // Handle +/- buttons
      const qtyBtn = e.target.closest('.flavor_qty-button');
      if (qtyBtn) {
        e.preventDefault();
        e.stopPropagation();
        
        const container = qtyBtn.closest('.flavor2_quantity-container');
        const display = container.querySelector('.flavor_qty-display');
        const addBtn = qtyBtn.closest('.flavor2_quantity-2').querySelector('.flavor_add-btn');
        
        let qty = parseInt(display.textContent, 10) || 0;
        
        if (qtyBtn.classList.contains('plus')) {
          qty++;
        } else if (qtyBtn.classList.contains('minus') && qty > 0) {
          qty--;
        }
        
        display.textContent = qty;
        
        if (qty === 0 && addBtn) {
          addBtn.classList.add('is-active');
        } else if (addBtn) {
          addBtn.classList.remove('is-active');
        }
        
        updateMeter();
        return;
      }
      
      // Handle "Tilføj +" button
      const addBtn = e.target.closest('.flavor_add-btn');
      if (addBtn) {
        e.preventDefault();
        e.stopPropagation();
        
        const container = addBtn.closest('.flavor2_quantity-2').querySelector('.flavor2_quantity-container');
        const display = container.querySelector('.flavor_qty-display');
        
        display.textContent = '1';
        addBtn.classList.remove('is-active');
        
        updateMeter();
        return;
      }
    });
  }

  // Add to cart - bundle
  if (addToCartBtn) {
    addToCartBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      const items = [];
      const activeList = getActiveFlavorsList();
      
      if (activeList) {
        activeList.querySelectorAll('.flavor_card-item').forEach(card => {
          const display = card.querySelector('.flavor_qty-display');
          const qty = parseInt(display.textContent, 10) || 0;
          if (qty > 0) {
            // Get the correct variant ID based on selected size
            const variantId = getVariantId(card);
            if (variantId) {
              items.push({ id: parseInt(variantId), quantity: qty });
            }
          }
        });
      }

      if (items.length === 0) {
        alert('Vælg mindst 1 parfume');
        return;
      }

      const btn = this;
      const originalHTML = btn.innerHTML;
      btn.innerHTML = '<span class="with-selected">TILFØJER...</span>';
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
      .then(res => res.json())
      .then(data => {
        if (data.status && data.status === 422) {
          alert('Fejl: ' + (data.description || 'Kunne ikke tilføje til kurv'));
          btn.innerHTML = originalHTML;
          btn.disabled = false;
        } else {
          // Success - open cart drawer without refresh
          btn.innerHTML = '<span class="with-selected">TILFØJET!</span>';
          setTimeout(() => {
            btn.innerHTML = originalHTML;
            btn.disabled = false;
            updateCartCount();
            openCartDrawer();
          }, 500);
        }
      })
      .catch(err => {
        console.error('Error:', err);
        alert('Netværksfejl. Prøv igen.');
        btn.innerHTML = originalHTML;
        btn.disabled = false;
      });
    });
  }

  // Add to cart - single
  if (singleAddBtn) {
    singleAddBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      const variantId = wrapper.querySelector('.variant-bundle-size.active')?.dataset.variantId;
      
      if (!variantId) {
        alert('Vælg venligst en størrelse');
        return;
      }

      const btn = this;
      const originalHTML = btn.innerHTML;
      btn.innerHTML = 'TILFØJER...';
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: parseInt(variantId), quantity: 1 }]
        })
      })
      .then(res => res.json())
      .then(data => {
        if (data.status && data.status === 422) {
          alert('Fejl: ' + (data.description || 'Kunne ikke tilføje til kurv'));
          btn.innerHTML = originalHTML;
          btn.disabled = false;
        } else {
          // Success - open cart drawer without refresh
          btn.innerHTML = 'TILFØJET!';
          setTimeout(() => {
            btn.innerHTML = originalHTML;
            btn.disabled = false;
            updateCartCount();
            openCartDrawer();
          }, 500);
        }
      })
      .catch(err => {
        console.error('Error:', err);
        alert('Netværksfejl. Prøv igen.');
        btn.innerHTML = originalHTML;
        btn.disabled = false;
      });
    });
  }

  // Add to cart - 5ml (simple, no bundle)
  if (fiveMlAddBtn) {
    fiveMlAddBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      const variantId = this.getAttribute('data-variant-id');
      
      if (!variantId) {
        alert('Variant ikke fundet');
        return;
      }

      const btn = this;
      const originalHTML = btn.innerHTML;
      btn.innerHTML = 'TILFØJER...';
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: parseInt(variantId), quantity: 1 }]
        })
      })
      .then(res => res.json())
      .then(data => {
        if (data.status && data.status === 422) {
          alert('Fejl: ' + (data.description || 'Kunne ikke tilføje til kurv'));
          btn.innerHTML = originalHTML;
          btn.disabled = false;
        } else {
          btn.innerHTML = 'TILFØJET!';
          setTimeout(() => {
            btn.innerHTML = originalHTML;
            btn.disabled = false;
            updateCartCount();
            openCartDrawer();
          }, 500);
        }
      })
      .catch(err => {
        console.error('Error:', err);
        alert('Netværksfejl. Prøv igen.');
        btn.innerHTML = originalHTML;
        btn.disabled = false;
      });
    });
  }

  // Initialize
  updatePriceDisplays();
  updateMeter();
  
  // Update main price SYNCHRONOUSLY on load using embedded data attributes
  const activeBtn = wrapper.querySelector('.variant-bundle-size.active');
  if (activeBtn) {
    const activeSize = activeBtn.dataset.size || '50ml';
    const priceAttr = wrapper.getAttribute('data-variant-' + activeSize + '-price');
    const compareAttr = wrapper.getAttribute('data-variant-' + activeSize + '-compare-price');
    
    if (priceAttr) {
      const formatPrice = (price) => {
        const priceInKr = price / 100;
        return priceInKr.toLocaleString('da-DK', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace('.', ',') + ' kr';
      };
      
      const price = parseInt(priceAttr);
      const comparePrice = parseInt(compareAttr) || 0;
      
      const priceSelectors = [
        '[data-js-product-price-original]',
        '.product-price--original',
        '.main-product-price .product-price--original',
        '.product-price .current-price'
      ];
      
      priceSelectors.forEach(selector => {
        document.querySelectorAll(selector).forEach(el => {
          el.textContent = formatPrice(price);
        });
      });
      
      const compareSelectors = [
        '[data-js-product-price-compare]',
        '.product-price--compare',
        '.main-product-price .product-price--compare',
        '.product-price .compare-price'
      ];
      
      compareSelectors.forEach(selector => {
        document.querySelectorAll(selector).forEach(el => {
          if (comparePrice && comparePrice > price) {
            if (el.classList.contains('compare-price')) {
              el.innerHTML = '<s>' + formatPrice(comparePrice) + '</s>';
              el.style.display = '';
            } else {
              el.innerHTML = '<span>' + formatPrice(comparePrice) + '</span>';
            }
          } else {
            el.innerHTML = '';
            if (el.classList.contains('compare-price')) {
              el.style.display = 'none';
            }
          }
        });
      });
    }
  }
  
  // If default selected variant is sold out, show BIS section
  if (activeBtn && activeBtn.dataset.soldOut === 'true') {
    const bisSection = wrapper.querySelector('.variant-bundle-bis-section');
    const bundleOpts = wrapper.querySelector('.variant-bundle-options');
    if (bisSection) bisSection.style.display = 'block';
    if (bundleOpts) bundleOpts.style.display = 'none';
  }
});
